<main>
  <section class="col-6 mx-auto">
    <header>
      <h1>Your Student Profile</h1>
    </header>

    <app-feedback></app-feedback>

    <ul ngbNav #t="ngbNav" class="nav-pills nav-fill">
      <li [ngbNavItem]="'profile'">
        <a ngbNavLink>Profile</a>
        <ng-template ngbNavContent>
          <app-profile></app-profile>
        </ng-template>
      </li>
      <li [ngbNavItem]="'billing'">
        <a ngbNavLink>Billing</a>
        <ng-template ngbNavContent>
          <app-billing></app-billing>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="t"></div>
  </section>
</main>
